function getStatusLabel(status) {
  const labels = {
    draft: 'Borrador',
    sent: 'Enviado',
    approved: 'Aprobado',
    invoiced: 'Facturado',
    collected: 'Cobrado'
  };

  return labels[status];
}

function FormatGroupInvoiceStatusFilter() {
  return status => {
    if (!status) return '';
    return getStatusLabel(status);
  };
}

export { FormatGroupInvoiceStatusFilter as default, getStatusLabel };
